import { PrizeWeightSection } from './prize-weight-filters-state.service';

export interface RequiredFiltersState {
  hasDateFilter: boolean;
  hasTagFilter: boolean;
  /** Weight sections (Daily/Remaining) that don't have at least one category configured yet. */
  weightSectionsMissingCategories: PrizeWeightSection[];
}

export interface MissingRequiredFilter {
  key: string;
  message: string;
}

/**
 * Pure function: given the current filter state, returns which of the "minimum required
 * filters" (a Date filter, a Tag filter, at least one category per weight section) are missing.
 * No Angular DI, no side effects — this is the seam the ticket asks for: once the real Date/Tag/
 * Weight filter components land, build a RequiredFiltersState from their real state and pass it
 * in here. This function's logic doesn't need to change.
 */
export function getMissingRequiredFilters(state: RequiredFiltersState): MissingRequiredFilter[] {
  const missing: MissingRequiredFilter[] = [];

  if (!state.hasDateFilter) {
    missing.push({
      key: 'date',
      message: 'Add a Date filter condition before filters can be saved or a new batch can be generated.',
    });
  }

  if (!state.hasTagFilter) {
    missing.push({
      key: 'tag',
      message: 'Add a Tag filter rule (include or exclude) before filters can be saved or a new batch can be generated.',
    });
  }

  state.weightSectionsMissingCategories.forEach((section) => {
    missing.push({
      key: `category:${section.key}`,
      message: `Add at least one category to ${section.label} before filters can be saved or a new batch can be generated.`,
    });
  });

  return missing;
}
